import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  LoadingContainer,
  LoadingSpinner,
  LoadingText,
  LoadingSubtext
} from '../styles/ProtectedRoute.styles';

function ProtectedRoute({ children, requiredUserType }) {
  const { isAuthenticated, loading, userType } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <LoadingContainer>
        <LoadingSpinner />
        <LoadingText>Verifying Authentication</LoadingText>
        <LoadingSubtext>Please wait while we check your credentials...</LoadingSubtext>
      </LoadingContainer>
    );
  }

  // If not authenticated, redirect to appropriate login page based on stored user type
  if (!isAuthenticated) {
    // Check if we have a stored user type to determine which login page to redirect to
    const storedUserType = localStorage.getItem('userType');
    let redirectPath;
    
    if (storedUserType === 'admin') {
      redirectPath = '/admin-login';
    } else if (storedUserType === 'presenter') {
      redirectPath = '/presenter-login';
    } else {
      // If no stored user type, redirect to landing page
      redirectPath = '/';
    }
    
    return <Navigate to={redirectPath} state={{ from: location }} replace />;
  }

  // If user type doesn't match required type, redirect to their appropriate portal
  if (requiredUserType && userType !== requiredUserType) {
    const redirectPath = userType === 'admin' ? '/admin' : '/presenter';
    return <Navigate to={redirectPath} replace />;
  }

  // If all checks pass, render the protected component
  return children;
}

export default ProtectedRoute; 